import React, { createContext, ReactNode, useContext, useRef } from 'react'

import { isFunction } from '@surglogs/util.is-function'

// NOTE: PORT of visage LayerManager modified for our use https://bit.ly/2VN2cOH

export interface LayerManagerState {
  /** Increases current zIndex by this number if level increases */
  increaseBy: number
  // current zIndex that should be used
  zIndex: number
}

export const LayerManagerContext = createContext<LayerManagerState>({
  increaseBy: 100,
  zIndex: 0,
})

LayerManagerContext.displayName = 'LayerManagerContext'

interface LayerManagerProps {
  children: ReactNode | ((value: LayerManagerState) => ReactNode)
  /**
   * Increases current zIndex by N (default is 100)
   */
  increaseBy?: number
}

/**
 * Uses current layer manager state for given LayerProvider
 */
export function useLayerManager() {
  return useContext(LayerManagerContext)
}

export function LayerManager({ children, increaseBy }: LayerManagerProps) {
  const ctx = useLayerManager()
  const valueRef = useRef<LayerManagerState | undefined>(undefined)

  // increase zIndex
  if (!valueRef.current) {
    valueRef.current = {
      increaseBy: increaseBy ?? ctx.increaseBy,
      zIndex: ctx.zIndex + (increaseBy ?? ctx.increaseBy),
    }
  }

  return (
    <LayerManagerContext.Provider {...{ value: valueRef.current }}>
      {isFunction(children) ? children(valueRef.current) : children}
    </LayerManagerContext.Provider>
  )
}
